
<div [ngClass]='container_class' (mouseover)="changeStyle($event)" (mouseout)="changeStyle($event)" (click)="clicked()">
  @if (data.productCode === 'Octopus') {
    <div>
    </div>
  } @else {
    <div (click)="clicked()">
      <div class="name-title">
        {{data.name}}
      </div>
      <hr>
        <div class="d-flex justify-content-between flex-row">
          <div class="icon-container">
            <i class="{{ icons.getIcon(data.productCode) }}" [style.margin-left]="margin"></i>
          </div>
        </div>
        <div class="bottom-container">
          Click to view data
        </div>
      </div>
    }
  </div>

